module.exports = __webpack_public_path__ + "static/1 (10)-7e3ba7b49f5d6bf132c1ff535c7a1d7d.png";